export default __webpack_public_path__ + "static/media/img-0144-india-full-face.cef385c2.png";